
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.495 20.476h15.01c1.535 0 2.492-1.665 1.725-2.99L13.724 4.518c-.767-1.325-2.681-1.325-3.448 0L2.77 17.486c-.767 1.325.19 2.99 1.725 2.99zM12 13.499a1 1 0 01-.997-.997v-1.993A1 1 0 0112 9.512a1 1 0 01.997.997v1.993a1 1 0 01-.997.997zm.997 3.987h-1.994v-1.994h1.994v1.994z","fill-rule":"nonzero"}})])
          )
        }
      }
    